<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Aceite de Termos de Uso e de Proteção de Dados
      </p>
    </div>

    <div v-if="dadosTermo.termo == null" class="row">
      <div class="col-md-4 q-ml-sm q-mt-sm">
        <div style="margin-left: 35px" class="text-weight-bold text-brand-5">
          Seu Pin:
        </div>
        <div class="row items-center container-autenticacao-pin">
          <q-icon class="q-mr-xs" name="lock" size="28px" />
          <div>
            <q-input v-model="pin" type="password" dense outlined />
          </div>
          <q-btn
            label="Assinar Termo"
            class="q-ml-sm"
            color="positive"
            dense
            no-caps
            icon="done"
            flat
            @click="verificarPin"
          />
        </div>
      </div>
    </div>

    <div v-else>
      <span style="font-weight: bolder">Data de Assinatura:</span>
      <span class="q-ml-sm">{{
        dadosTermo.termo.split(" ")[0].split("-").reverse().join("/")
      }}</span>
      <span class="q-ml-sm">{{ dadosTermo.termo.split(" ")[1] }}</span>
    </div>

    <section class="q-mt-lg">
      <p>
        Eu,
        <span style="font-weight: bolder">{{ dadosTermo.nome }}</span
        >, matricula número
        <span style="font-weight: bolder">{{ dadosTermo.matricula }}</span
        >, declaro estar ciente dos termos e avisos presentes abaixo,
        confirmando atrvés de assinatura eletrônica com meu PIN pessoal.
      </p>
    </section>

    <section class="q-mt-md">
      <iframe
        style="height: 1000px"
        width="100%"
        src="https://multpex-docs.s3.amazonaws.com/termos-e-documentos/vale-epiexpress/Termo+de+Responsabilidade+e+Aviso+Privacidade+-+2022-09-06.pdf?#zoom=170"
        frameborder="0"
      ></iframe>
    </section>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useQuasar } from "quasar";
import { onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const todasUnidades = ref(0);
    const route = useRoute();
    const pin = ref("");
    const dadosTermo = ref(JSON.parse(route?.params?.id));
    const unidade = ref();

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const assinarTermo = async () => {
      try {
        await store.dispatch("user/assinarTermo", {
          id: dadosTermo.value.id,
        });
        quasar.notify({
          message: "Termo Assinado com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        let usuario = await store.dispatch("user/getUsuarios", {
          search: dadosTermo.value.matricula,
        });
        const usuarioCorreto = await usuario.data.results.data.find((e) => {
          return e.id == dadosTermo.value.id;
        });

        dadosTermo.value = {
          termo: usuarioCorreto.data_aceite_biometria,
          id: usuarioCorreto.id,
          matricula: usuarioCorreto.sap,
          nome: usuarioCorreto.name,
        };
      } catch (error) {
        quasar.notify({
          message: "Erro a o assinar termo",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo de pin não pode ser vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: dadosTermo.value.id,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message: "Senha Validada com Sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          assinarTermo();
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      todasUnidades,
      unidade,
      pin,
      dadosTermo,
      verificarPin,
      assinarTermo,
      options: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Cadastrados",
          value: true,
        },
        {
          label: "Não Cadastrado",
          value: false,
        },
      ],
    };
  },
};
</script>
